module.exports = __webpack_public_path__ + "media/4x3/ug-be11ef39.svg";